// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlogsModal_modal__SPj7R .modal-dialog {
  max-width: 1250px !important;
  width: 94vw !important;
  margin: 1.75rem auto;
}

.BlogsModal_modal__SPj7R .modal-content {
  max-height: 92vh;
  border-radius: 16px;
  position: relative;
  overflow: visible;
  display: flex;
  flex-direction: column;
}

.BlogsModal_modal__SPj7R .modal-body {
  padding: 0px 35px 25px 35px !important;
  overflow-y: auto;
}

.BlogsModal_header__-qpAA {
  padding: 30px 35px 15px 35px !important;
  background-color: var(--white-color) !important;
  border: none;
}

.BlogsModal_heading__79v5A {
  color: var(--black-dark-text-color) !important;
  font-size: 22px !important;
  font-weight: 700 !important;
}

.BlogsModal_mainDiv__-DvAH {
  width: 100%;
}

.BlogsModal_leftColumn__PpxX2 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.BlogsModal_rightColumn__N839u {
  display: flex;
  flex-direction: column;
}

.BlogsModal_rightColumn__N839u .quill {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.BlogsModal_rightColumn__N839u .ql-container {
  flex: 1 1;
  min-height: 380px !important;
  max-height: 480px;
}

.BlogsModal_imageUploadGrid__h1kIl {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.BlogsModal_imageUploadCard__IvvwI {
  background: var(--white-color-v1, #f8fafc);
  border: 1px solid rgba(142, 142, 142, 0.2);
  border-radius: 12px;
  padding: 16px;
}

.BlogsModal_thumbnailBoxContainer__wDC2P {
  width: 140px;
  height: 140px !important;
}

.BlogsModal_bannerBoxContainer__PtZGg {
  width: 100%;
  max-width: 340px;
  height: 150px !important;
}

.BlogsModal_uploadBoxStyle__EXS3v {
  background: var(--white-color);
  border: 2px dashed rgba(142, 142, 142, 0.45);
  border-radius: 8px;
}

.BlogsModal_thumbnailImagePreview__kC3ou {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  aspect-ratio: 1 / 1;
}

.BlogsModal_bannerImagePreview__SwrVm {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  aspect-ratio: 16 / 9;
}

.BlogsModal_buttonDiv__UUvFS {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid rgba(142, 142, 142, 0.15);
}

.BlogsModal_dropDownContainer__V8ODG > div > div > div {
  padding-left: 10px;
}

.BlogsModal_myLabel__XC5ag {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 6px;
}`, "",{"version":3,"sources":["webpack://./src/Components/molecules/BlogsModal/BlogsModal.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,+CAA+C;EAC/C,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".modal :global(.modal-dialog) {\n  max-width: 1250px !important;\n  width: 94vw !important;\n  margin: 1.75rem auto;\n}\n\n.modal :global(.modal-content) {\n  max-height: 92vh;\n  border-radius: 16px;\n  position: relative;\n  overflow: visible;\n  display: flex;\n  flex-direction: column;\n}\n\n.modal :global(.modal-body) {\n  padding: 0px 35px 25px 35px !important;\n  overflow-y: auto;\n}\n\n.header {\n  padding: 30px 35px 15px 35px !important;\n  background-color: var(--white-color) !important;\n  border: none;\n}\n\n.heading {\n  color: var(--black-dark-text-color) !important;\n  font-size: 22px !important;\n  font-weight: 700 !important;\n}\n\n.mainDiv {\n  width: 100%;\n}\n\n.leftColumn {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.rightColumn {\n  display: flex;\n  flex-direction: column;\n}\n\n.rightColumn :global(.quill) {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.rightColumn :global(.ql-container) {\n  flex: 1;\n  min-height: 380px !important;\n  max-height: 480px;\n}\n\n.imageUploadGrid {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.imageUploadCard {\n  background: var(--white-color-v1, #f8fafc);\n  border: 1px solid rgba(142, 142, 142, 0.2);\n  border-radius: 12px;\n  padding: 16px;\n}\n\n.thumbnailBoxContainer {\n  width: 140px;\n  height: 140px !important;\n}\n\n.bannerBoxContainer {\n  width: 100%;\n  max-width: 340px;\n  height: 150px !important;\n}\n\n.uploadBoxStyle {\n  background: var(--white-color);\n  border: 2px dashed rgba(142, 142, 142, 0.45);\n  border-radius: 8px;\n}\n\n.thumbnailImagePreview {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 8px;\n  aspect-ratio: 1 / 1;\n}\n\n.bannerImagePreview {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 8px;\n  aspect-ratio: 16 / 9;\n}\n\n.buttonDiv {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 18px;\n  padding-top: 14px;\n  border-top: 1px solid rgba(142, 142, 142, 0.15);\n}\n\n.dropDownContainer > div > div > div {\n  padding-left: 10px;\n}\n\n.myLabel {\n  font-size: 14px;\n  font-weight: 700;\n  margin-bottom: 6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `BlogsModal_modal__SPj7R`,
	"header": `BlogsModal_header__-qpAA`,
	"heading": `BlogsModal_heading__79v5A`,
	"mainDiv": `BlogsModal_mainDiv__-DvAH`,
	"leftColumn": `BlogsModal_leftColumn__PpxX2`,
	"rightColumn": `BlogsModal_rightColumn__N839u`,
	"imageUploadGrid": `BlogsModal_imageUploadGrid__h1kIl`,
	"imageUploadCard": `BlogsModal_imageUploadCard__IvvwI`,
	"thumbnailBoxContainer": `BlogsModal_thumbnailBoxContainer__wDC2P`,
	"bannerBoxContainer": `BlogsModal_bannerBoxContainer__PtZGg`,
	"uploadBoxStyle": `BlogsModal_uploadBoxStyle__EXS3v`,
	"thumbnailImagePreview": `BlogsModal_thumbnailImagePreview__kC3ou`,
	"bannerImagePreview": `BlogsModal_bannerImagePreview__SwrVm`,
	"buttonDiv": `BlogsModal_buttonDiv__UUvFS`,
	"dropDownContainer": `BlogsModal_dropDownContainer__V8ODG`,
	"myLabel": `BlogsModal_myLabel__XC5ag`
};
export default ___CSS_LOADER_EXPORT___;
